import _ from "lodash";
import { useEffect } from "react";
import { useState } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../finwell/pages/Page";
import {
	getLevelDetailReq, getLevelDetailResponseClear,
	getModuleListingClearBroker, getSelectedCatId,
	getModuleListingClear,
	getMyLearningPaths,
	getCheckListInsert,
	getMyLearningPathsClear
} from "../../redux/courses/actions";
import { convertTimeFormat, convertTimeInHourAndMin, getEntityType, getProcureInfo, SessionKeys } from "../../utils/AppUtils";
import BreadCrumbComponent from "../../components/NewDesign/Misc/BreadCrumb/BreadCrumbComponent";
import ShimmerScreen from "../../components/Layouts/ShimmerScreen";
import { Tab, Tabs } from "react-bootstrap";
import DetailPageDiscussComponent from "../../components/NewDesign/DetailPage/DetailPageDiscuss/DetailPageDiscussComponent";
import LPdetailComp from "../../components/b2cComponents/LPDetailComp";
import CartBandComponent from "../../components/NewDesign/DetailPage/CartBand/CartBandComponent";
import CartPopUpComponent from "../../components/NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import useLogin from "../../custom-hooks/useLogin";
import DetailPageBannerHeaderComponent from "../../components/NewDesign/DetailPage/DetailPageBannerHeader/DetailPageBannerHeaderComponent";
import { routeList } from "../../utils/routeList";
import Loader from "../../components/Loader/Loader";
import { useTranslation } from "react-i18next";
const BundleDetailPage = ({isMobile}) => {
	const [isOpenMenu, setIsOpenMenu] = useState(false);
    const {t} = useTranslation();
	const toggleMenu = () => {
		setIsOpenMenu(!isOpenMenu);
	};
	const closeMenu = () => {
		setIsOpenMenu(false);
	};
	const dispatch = useDispatch();
	const { isLoggedIn } = useLogin()
	const search = window.location.search;
	const params = new URLSearchParams(search);
	// const level_id = params.get('level_id');
	// const lp_id = params.get('lp_id');
	// const fromLevel = params.get('is_level')
	// const source = params.get('source')

	const c = params.get("c");
	let decodedString = atob(c);
	let paramsReq = JSON.parse(decodedString);
	const level_id = paramsReq?.level_id;
	const lp_id = paramsReq?.lp_id;
	const fromLevel = paramsReq?.is_level;
	const source = paramsReq?.source;
	const via = paramsReq?.via;

	const [isLoading, setIsLoading] = useState(false)
	const [closeChildModal, setCloseChildModal] = useState(true);

	const levelDetails = useSelector(state => state.courses.getLevelDetail)
	const myLearningPathsData = useSelector(state => state.courses.myLearningPaths)
	
	const [levelDetail, setLevelDetail] = useState()
	const [learningPathData, setLearningPathData] = useState({});
	const [headerProdData, setHeaderProdData] = useState({})
	const activeLanguage = useSelector((state) => state.home.activeLanguage);
	// const [fromLevel, setFromLevel] = useState(false);

	const [showShimmer, setShowShimmer] = useState(false);
	const [key, setKey] = useState("learn");

	const [breadCrumbData, setBreadCrumbData] = useState([
		{ name: t("learn"), active: false, link: "", isLoading: false },
		{ name: t("combo&Offers"), active: false, link: "", isLoading: false },
		{ name: "-", active: false, link: "", isLoading: true },
	]);

	const [purchasedInfo, setPurchasedInfo] = useState({})
	const [isPaid, setIsPaid] = useState(false)
	const [price, setPrice] = useState(false)
	const [isInCart, setIsInCart] = useState(false)
	const addToCartRes = useSelector((state) => state.product.addToCart);



	useEffect(() => {

		if (fromLevel === "true") {
			setShowShimmer(true)
			window.scrollTo(0, 0);
			dispatch(getLevelDetailReq({
				module: "getLevelDetail",
				postData: {
					token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
					program_id: lp_id,
					level_id: level_id,
					language: activeLanguage ? activeLanguage : ""
				}
			}))
		} else {

			setShowShimmer(true)
			callLPDetailApi()
		}

	}, [lp_id, level_id, fromLevel])

	const callLPDetailApi = () => {
		if (source === "xsel" || source === "ecom") {
			dispatch(getMyLearningPaths({
				module: 'getBundleDetailReq',
				postData: {
					token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
					bundle_id: lp_id,
				}
			}))
		} else {
			dispatch(getMyLearningPaths({
				module: 'getMyLearningPaths',
				postData: {
					token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
					assigned: 0,
					lp_id: lp_id,
					language: activeLanguage ? activeLanguage : ""
				}
			}))
		}
	}


	const getFormatedData = (learning) => {
		let sendFlag = false;
		console.log('lpDetail: ', learning)


		learning.duration = convertTimeFormat(_.toNumber(learning.duration), true, t);
		if (learning.coursesList) {
			learning.is_manager_checklist = false;
			for (let [index, course] of learning.coursesList.entries()) {
				let currentCourse = course;
				let nextCourse = learning.coursesList[index + 1];
				console.log('CURRENT COURSE', currentCourse)
				console.log('NEXT COURSE', nextCourse)
				if (learning.sequence === 1) {
					console.log('is sequence');
					if (index === 0) {
						currentCourse.isLock = false;
					}
					currentCourse.isLock = currentCourse.isLock === false ? currentCourse.isLock : true;
					if (currentCourse.crs_progress > 0) {
						console.log('CURRENT PROGRESS IS MORE THAN ZERO')
						// currentCourse.isLock = currentCourse.crs_progress >= 100 ? false;
						if (index !== learning.coursesList.length - 1) {
							console.log("INDEX IS NOT LAST")
							nextCourse.isLock = (_.toNumber(currentCourse.crs_progress) >= 100 && !currentCourse.isLock) ? false : true;
							console.log('NEXT COURSE ISLOCK', nextCourse.isLock)
						}
					}
				} else {
					currentCourse.isLock = currentCourse.isLock ? currentCourse.isLock : false;
				}
				currentCourse.duration = convertTimeFormat(_.toNumber(currentCourse.duration), true, t);
				currentCourse.durationUnit = ''
				// console.log("detaiiii", course)


				// will uncomment this when checklist is available in B2C
				if (index < learning.coursesList.length - 1) {
					if (!currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present) {
						nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false
					} else if ((currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present)) {
						nextCourse.isLock = false
					}

					if (currentCourse.is_checklist_present) {
						learning.is_manager_checklist = true;
					}
				}

				if (!currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present && !sendFlag) {
					if (currentCourse.crs_progress >= 100 && !currentCourse.isLock &&
						(index !== learning.coursesList.length - 1)) {
						dispatch(
							getCheckListInsert({
								module: 'checklist-insert',
								postData: {
									token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
									lp_id: learning?.id,
									entity_id: currentCourse.source === 'broker' ? currentCourse.id : currentCourse?.crscd,
									entity_type: !currentCourse?.is_level ? currentCourse.entity_type : "level"
								}
							}))
						sendFlag = true;
					}
				}
			}
			for (let course of learning.coursesList) {
				course.is_manager_checklist = learning.is_manager_checklist
			}


			let priceInfo = getProcureInfo(learning.purchased_info)
			priceInfo.isAddToCart = learning.is_addtocart;
			console.log('PRICE INFO', priceInfo)
			let tags = [];
			let logoURL = ''
			if (!_.isEmpty(learning.provider)) {
				tags.push(learning.provider.provider_display_name)
				logoURL = learning.provider.provider_img;
			}
			// tags.push('Combo')
			// if (learning.provider?.provider_display_name) {
			// 	tags.push(learning.provider.provider_display_name)
			// }
			// tags.push(getEntityType(learning.entity_type))

			
			if (learning.course_count) {
				tags.push(`${learning.course_count} Course${learning.course_count > 1 ? "s" : ""}`);
			}
			if (learning.video_count) {
				tags.push(`${learning.video_count} Video${learning.video_count > 1 ? "s" : ""}`);
			}
			if (learning.learningpath_count) {
				tags.push(`${learning.learningpath_count} Action Path${learning.learningpath_count > 1 ? "s" : ""}`);
			}
			if (learning.level_count) {
				tags.push(`${learning.level_count} Level${learning.level_count > 1 ? "s" : ""}`);
			}
			if (learning.event_count) {
				tags.push(`${learning.event_count} Event${learning.event_count > 1 ? "s" : ""}`);
			}
			if (learning.duration) tags.push(learning.duration)
			// if (learning.entity_type === "course" && learning.lessons) {
			// 	tags.push(`${learning.lessons} Module${learning.lessons > 1 ? 's' : ''}`)
			// } else if (learning.entity_type === "level") {
			// 	if (learning.course_count > 0)
			// 		tags.push(`${learning.course_count} Course${learning.course_count > 1 ? 's' : ''}`)
			// 	else if (learning.video_count > 0)
			// 		tags.push(`${learning.video_count} Video${learning.video_count > 1 ? 's' : ''}`)
			// 	else if (learning.event_count > 0)
			// 		tags.push(`${learning.event_count} Event${learning.event_count > 1 ? 's' : ''}`)
			// }
			if (!isLoggedIn) priceInfo.isFree = false;
			setHeaderProdData({
				id: learning.ecom_id,
				title: learning.prgm_nm,
				logoURL: logoURL,
				logoAltText: 'VD',
				bannerURL: learning.banner,
				tagsArray: tags,
				description: learning.prgm_description,
				duration: '',
				view: learning.views,
				price: priceInfo.price,
				isPaid: priceInfo.isPurchased,
				priceInfo: priceInfo,
				purchaseInfo: learning.purchased_info,
				banner: learning.banner,
				isBundle: true,
				bundleList: !_.isEmpty(learning.coursesList) ?
					_.map(learning.coursesList, (record) => {
						return {
							id: record.id,
							thumbnail: record.imageURL
						}
					}) : []
			})

			if ((source === "xsel" || source === "ecom") && !_.isEmpty(learning.purchased_info)) {
				const purchased_info = learning.purchased_info;
				console.log('courseDetailEcom', purchased_info)
				if (purchased_info.is_purchased ||
					_.toNumber(purchased_info.selling_price) == 0) {
					setIsPaid(false)
					setPrice(0)
				} else {
					setIsPaid(true)
					setPrice(_.toNumber(purchased_info.selling_price))
					for (let course of learning.coursesList) {
						course.isLock = true
					}

				}
				setIsInCart(learning.is_addtocart)
			}


		}

		return learning;

	}


	useEffect(() => {
		// console.log('LearningPath', myLearningPathsData)
		if (!_.isEmpty(myLearningPathsData)) {
			setShowShimmer(false)
			if (myLearningPathsData.status === 'success') {
				setIsLoading(false);
				if (!_.isEmpty(myLearningPathsData.payload.payload)) {
					let learning = _.cloneDeep(myLearningPathsData.payload.payload)
					// console.log('learningPath', learningData)

					let learningData = getFormatedData(learning)
					let bCBData = [
						{ name: t("learn"), active: false, link: routeList.LEARN_COMBO_PAGE, isLoading: false }
					];

					if (via === 'video') {
						bCBData.push({ name: t("videos"), active: false, link: routeList.LEARN_VIDEOS_PAGE, isLoading: false })
					} else if (via === 'course') {
						bCBData.push({ name: t("courses"), active: false, link: routeList.LEARN_COURSES_PAGE, isLoading: false })
					} else if (via === 'learningpath') {
						bCBData.push({ name: t("courses"), active: false, link: routeList.LEARN_LEARNING_PATH_PAGE, isLoading: false })
					}

					bCBData.push({ name: t("combo&Offers"), active: false, link: "/learn/combo", isLoading: false })

					bCBData.push({
						name: learningData.prgm_nm,
						active: true,
						link: "",
						isLoading: false,
					})



					setBreadCrumbData(bCBData);

					console.log(learningData)
					setLearningPathData(learningData)
				}
			}
			dispatch(getMyLearningPathsClear())
		}
	}, [myLearningPathsData])



	useEffect(() => {
		console.log('levelDetails: ', levelDetails);

		if (!_.isEmpty(levelDetails)) {
			setShowShimmer(false)
			if (levelDetails?.status === 'success') {
				if (!_.isEmpty(levelDetails?.payload?.payload)) {
					const learning = _.cloneDeep(levelDetails?.payload?.payload);
					let learningData = getFormatedData(learning)

					let paramsReq = {
						lp_id: lp_id,
						is_level: "false",
						source: source
					}
					let jsonString = JSON.stringify(paramsReq);
					let encodedUrl = btoa(jsonString);

					setBreadCrumbData([
						{ name: t("learn"), active: false, link: "/learn/courses?tab=3", isLoading: false },
						{ name: t("combo&Offers"), active: false, link: "/learn/combo", isLoading: false },
						{
							name: learningData.lp_name,
							active: false,
							link: `/lpDetail?c=${encodedUrl}`,
							isLoading: false,
						},
						{
							name: t("Level"),
							active: false,
							link: `/lpDetail?c=${encodedUrl}`,
							isLoading: false,
						},
						{
							name: learningData.prgm_nm,
							active: true,
							link: "",
							isLoading: false,
						},
					]);

					setLearningPathData(learningData)
				}


			}
		}

	}, [levelDetails])

	useEffect(() => {
		return (() => {
			dispatch(getLevelDetailResponseClear())
		})
	}, [])

	useEffect(() => {
		if (!_.isEmpty(addToCartRes)) {
			setIsLoading(false)
			callLPDetailApi();
		}
	}, [addToCartRes]);


	return (
		<>
			<Loader start={isLoading} />
			<Page>

				<section className="bannersection-sec">
					<div class="bannersection bgba">


						{showShimmer ? <ShimmerScreen
							case={'rect'}
							width={'100%'}
							height={'358px'}
						/> :
							!_.isEmpty(headerProdData) && !headerProdData?.priceInfo?.isFree ?
								<DetailPageBannerHeaderComponent
									bannerURL={headerProdData?.banner}
									btnName={t("Purchase to unlock")}
									productData={headerProdData}
									showTagLine={!_.isEmpty(headerProdData.priceInfo.showText)}
									showShareIcon={true}
									showCartBtn={isLoggedIn ? true : headerProdData.price > 0}
									tagLine={`${headerProdData.priceInfo.showText}`}
									rightTagLine={`${headerProdData.purchaseInfo.offer_ends_on_text ? 
										headerProdData.purchaseInfo.offer_ends_on_text : ""}`}
									setIsMainPageLoading={setIsLoading}
								/>


								: headerProdData.banner ?
									<>
										<div className="bannerrimg">
										<img src={headerProdData.banner} alt="Banner" className="banner-image" />
										</div>

										{/* <img className="w-100"
									src={headerProdData.banner}
									alt={learningPathData?.prgm_nm}
								/> */}
									</>

									: <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center">
										<p
											dangerouslySetInnerHTML={{
												__html: learningPathData?.prgm_nm,
											}}
										></p>
									</div>}


						<div class="container posr">
							<div className="container-chart">
								<div className="box-progress">
									{false && <div
										className="circularProgress"
										style={{
											width: 150,
											height: 150,
											position: "relative",
										}}
									>
										<CircularProgressbar
											value={learningPathData?.prgm_progress}
											styles={buildStyles({
												pathColor:
													learningPathData?.prgm_progress < 100 ? `var(--color-element-1, #415385)` : "var(--color-element-1, #415385)", //FF9700=yellow
												trailColor: "#EAECF0",
											})}
										/>
										<div
											style={{
												position: "absolute",
												top: "0",
												bottom: "0",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												flexDirection: "column",
												width: "150px",
												textAlign: "center",
											}}
										>
											{learningPathData?.prgm_progress > -1 ? (
												<>
													<div className="comtext">{t("Completed so far")}</div>
													<strong className="percent">{`${learningPathData?.prgm_progress.toFixed(
														0
													)}%`}</strong>
												</>
											) : (
												""
											)}
										</div>
									</div>}
								</div>
							</div>
						</div>


						{_.isEmpty(learningPathData?.purchased_info) &&
							<CartBandComponent
								showTagLine={learningPathData?.source === 'broker' ? false : isPaid}
								showBtn={learningPathData?.source === 'broker' ? false : isPaid}
								showShareIcon={true}
								tagLine={`Price: CA $${price}`}
								btnName={t("Purchase to unlock")}
								btnAction={() => { }}
							/>
						}
					</div>
					<div className="container">
						<BreadCrumbComponent crumbList={breadCrumbData} />
					</div>
					<div class="container">
						<div className="row">
							<div className="col-xl-2">
								{false && <div class="leftmenusec sec-I">
									<div className="d-xl-none btn-filter-mob" onClick={toggleMenu}>
										Menu
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="22"
											height="22"
											viewBox="0 0 22 22"
											fill="none"
										>
											<path
												d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
												fill="#2D2D2D"
											/>
										</svg>
									</div>
									<ul className={`sidebar ${isOpenMenu ? 'openMenu' : ''}`}>
										<span className="close-menu d-xl-none cursor-pointer" onClick={toggleMenu}>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
												<path d="M15.1484 13.5781C15.5703 14.0469 15.5703 14.75 15.1484 15.1719C14.6796 15.6406 13.9765 15.6406 13.5546 15.1719L8.02344 9.59375L2.44532 15.1719C1.97656 15.6406 1.27344 15.6406 0.851559 15.1719C0.382814 14.75 0.382814 14.0469 0.851559 13.5781L6.42969 8L0.851559 2.42188C0.382814 1.95312 0.382814 1.25 0.851559 0.828125C1.27344 0.359375 1.97656 0.359375 2.39844 0.828125L8.02344 6.45312L13.6015 0.875C14.0234 0.40625 14.7265 0.40625 15.1484 0.875C15.6172 1.29688 15.6172 2 15.1484 2.46875L9.57034 8L15.1484 13.5781Z" fill="#2D2D2D" />
											</svg>
										</span>
										<li class="activemenu" onClick={closeMenu}>Intro</li>
										{learningPathData?.coursesList && learningPathData?.coursesList.length > 0
											? learningPathData?.coursesList?.map((item, index) => {
												return (
													<li title={item.name}
														onClick={() => {
															closeMenu()
															window.scrollTo({
																top: document.getElementById(`course-lp-${item.id}`).offsetTop - 100,
																left: 0,
																behavior: 'smooth'
															});

														}}>
														{/* {getEntityType(item.entity_type)} */}
														<span className="text-ellipsis">{item.name}</span>
														<span class="lock-bar unlock-bar"></span>
													</li>
												);
											})
											: ""}
									</ul>
								</div>}
							</div>
							<div className="col-xl-6">
								<div class="contsection sec-II">
									{
										<div className="learn-discuss">
											<Tabs
												underline
												activeKey={key}
												onSelect={(k) => setKey(k)}
											>
												{
													<Tab eventKey={'learn'} title={t("Combo Details")}>
														<LPdetailComp contentList={learningPathData?.coursesList}
															lpDetail={learningPathData}
															showShimmer={showShimmer}
															hideForBundle={isPaid}
															fromPage={"bundle"} 
															isMobile={false}
															/>
															
													</Tab>
												}
												{
													isLoggedIn && localStorage.getItem(SessionKeys.SHOW_DISCUSS_TAB) !== "false" && false ?
														<Tab eventKey={'discuss'} title="Discuss">
															<DetailPageDiscussComponent
																id={lp_id}
																code={""}
																type={"learningpath"}
																source={"broker"}
																isMobile={false}
															/>
														</Tab> : ""
												}
											</Tabs>
										</div>
									}
								</div>
							</div>

							<div className="col-xl-4">
								{
									// 	<RightPanelComponent
									// 	id={cid}
									// 	code={courseId}
									// 	type={'course'}
									// 	source={source}
									// />
								}
							</div>
						</div>

					</div>
				</section>
				{
					// <CartPopUpComponent
					// 	isOpen={isOpen}
					// 	productData={headerProdData}
					// 	closeAction={() => setIsOpen(false)}
					// 	isSubscription={false}
					// />
				}


			</Page>
		</>
	)


}

export default BundleDetailPage;